import React from 'react'

export const HamburgerIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width={24} height={22} viewBox="0 0 24 22">
    <title>Hamburger Icon</title>
    <g className="highcharts-exporting-group" data-z-index="3">
      <g className="highcharts-no-tooltip highcharts-button highcharts-contextbutton" strokeLinecap="round">
        <title>Chart context menu</title>
        <rect
          fill="#ffffff"
          className="highcharts-button-box"
          x="0.5"
          y="0.5"
          width="24"
          height="22"
          rx="2"
          ry="2"
          stroke="none"
          strokeWidth="1"
        ></rect>
        <path
          fill="#666666"
          d="M 6 6.5 L 20 6.5 M 6 11.5 L 20 11.5 M 6 16.5 L 20 16.5"
          className="highcharts-button-symbol"
          data-z-index="1"
          stroke="#666666"
          strokeWidth="3"
        ></path>
      </g>
    </g>
  </svg>
)
